import MembershipService from "./service/index.js";
import MembershipClient from "./client/index.js";
export default MembershipService;
export { MembershipClient };
export const defaultClient = new MembershipClient();
export const defaultService = new MembershipService({
  client: defaultClient
});